/* ==========================================================================
   Femme Bliss — mobile UX enhancements (added 2026-09-15)

   1. Sticky add-to-cart bar on product pages (phones only)
   2. Long product descriptions collapsed into accordions (phones only)
   3. Wide tables in rich text wrapped in a horizontal scroller

   Everything is additive and guarded: if the expected markup is missing the
   script does nothing.
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 749px)');

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* ---------------------------------------------------------------- 1 ----- */
  function initStickyAtc() {
    if (!MOBILE.matches) return;

    var main = document.querySelector('main[data-template]');
    if (!main || (main.dataset.template || '').indexOf('product') !== 0) return;

    // NB: the Shop Pay installment widget also renders a form posting to
    // /cart/add, so find the real form via the add-to-cart button instead.
    function getAddButton() {
      return (
        document.querySelector('product-form button[name="add"]') ||
        document.querySelector('product-form .product-form__submit') ||
        document.querySelector('button[name="add"]')
      );
    }

    var realButton = getAddButton();
    if (!realButton) return;

    var titleEl = document.querySelector('.product__title h1, .product__title h2, h1.product__title');
    var imageEl = document.querySelector('.product__media img, .product-media-container img');

    var bar = document.createElement('div');
    bar.className = 'fb-sticky-atc';
    bar.setAttribute('data-visible', 'false');

    var mediaHtml = '';
    if (imageEl && imageEl.currentSrc) {
      mediaHtml =
        '<span class="fb-sticky-atc__media"><img alt="" src="' +
        imageEl.currentSrc.replace(/"/g, '&quot;') +
        '"></span>';
    }

    bar.innerHTML =
      mediaHtml +
      '<span class="fb-sticky-atc__info">' +
      '<span class="fb-sticky-atc__title"></span>' +
      '<span class="fb-sticky-atc__price"></span>' +
      '</span>' +
      '<button type="button" class="fb-sticky-atc__button"></button>';

    var barTitle = bar.querySelector('.fb-sticky-atc__title');
    var barPrice = bar.querySelector('.fb-sticky-atc__price');
    var barButton = bar.querySelector('.fb-sticky-atc__button');

    barTitle.textContent = titleEl ? titleEl.textContent.trim() : '';

    function labelFor(button) {
      var span = button.querySelector('span:not(.visually-hidden)');
      var text = (span ? span.textContent : button.textContent) || '';
      text = text.trim();
      return text || 'Add to cart';
    }

    function sync() {
      var current = getAddButton();
      if (!current) return;
      realButton = current;
      barButton.textContent = labelFor(current);
      var off = current.hasAttribute('disabled') || current.getAttribute('aria-disabled') === 'true';
      if (off) {
        barButton.setAttribute('disabled', 'disabled');
      } else {
        barButton.removeAttribute('disabled');
      }

      var p = document.querySelector('.price__container .price-item--sale, .price__container .price-item--regular');
      if (p) barPrice.textContent = p.textContent.trim();

      var img = document.querySelector('.product__media img, .product-media-container img');
      var barImg = bar.querySelector('.fb-sticky-atc__media img');
      if (img && barImg && img.currentSrc) barImg.src = img.currentSrc;
    }

    sync();

    barButton.addEventListener('click', function () {
      if (barButton.hasAttribute('disabled')) return;
      var current = getAddButton();
      if (current) current.click();
    });

    document.body.appendChild(bar);
    document.body.classList.add('fb-has-sticky-atc');

    // Show the bar once the real button has scrolled out of view.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.setAttribute('data-visible', entry.isIntersecting ? 'false' : 'true');
          });
        },
        { rootMargin: '0px 0px -60px 0px' }
      );
      io.observe(realButton.closest('.product-form__buttons') || realButton);
    } else {
      bar.setAttribute('data-visible', 'true');
    }

    // Keep price / availability in step with variant changes.
    var container = document.querySelector('product-info');
    if (container && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        sync();
      });
      mo.observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
    }
  }

  /* ---------------------------------------------------------------- 2 ----- */
  function initDescriptionAccordion() {
    if (!MOBILE.matches) return;

    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.fbAccordion === 'done') return;

    var nodes = Array.prototype.slice.call(desc.children);
    var headings = nodes.filter(function (n) {
      return /^H[23]$/.test(n.tagName);
    });

    // Only worth collapsing when there is real structure and real length.
    if (headings.length < 3 || desc.textContent.trim().length < 900) return;

    var intro = document.createDocumentFragment();
    var groups = [];
    var current = null;

    nodes.forEach(function (node) {
      if (/^H[23]$/.test(node.tagName)) {
        current = { heading: node, body: [] };
        groups.push(current);
      } else if (current) {
        current.body.push(node);
      } else {
        intro.appendChild(node);
      }
    });

    if (!groups.length) return;

    var frag = document.createDocumentFragment();
    frag.appendChild(intro);

    groups.forEach(function (group, index) {
      var details = document.createElement('details');
      details.className = 'fb-acc';
      if (index === 0) details.open = true;

      var summary = document.createElement('summary');
      summary.textContent = group.heading.textContent.trim();
      details.appendChild(summary);

      var body = document.createElement('div');
      body.className = 'fb-acc__body';
      group.body.forEach(function (node) {
        body.appendChild(node);
      });
      details.appendChild(body);

      frag.appendChild(details);
    });

    desc.innerHTML = '';
    desc.appendChild(frag);
    desc.dataset.fbAccordion = 'done';
  }

  /* ---------------------------------------------------------------- 3 ----- */
  function initTableScrollers() {
    var scopes = document.querySelectorAll('.rte, .article-template__content, .product__description');
    Array.prototype.forEach.call(scopes, function (scope) {
      var tables = scope.querySelectorAll('table');
      Array.prototype.forEach.call(tables, function (table) {
        if (table.parentNode && table.parentNode.classList.contains('fb-table-scroll')) return;
        var wrap = document.createElement('div');
        wrap.className = 'fb-table-scroll';
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
      });
    });
  }

  ready(function () {
    try {
      initTableScrollers();
    } catch (e) {}
    try {
      initDescriptionAccordion();
    } catch (e) {}
    try {
      initStickyAtc();
    } catch (e) {}
  });
})();
